<div class="main-container">
    <div class="header-container">
        <p *ngIf="emailDomain?.domain" i18n="@@EditDomain" t="EditDomain">Edit Domain</p>
        <p *ngIf="!emailDomain?.domain" i18n="@@AddDomain" t="AddDomain">Add Domain</p>
    </div>
    <app-domain-edit #domainEdit class="bank-edit" [tsl-initialValue]="emailDomain" [tsl-readOnly]="false"
        [tsl-hideSaveButton]="true" [tsl-domainDifferenceReasons]="domainDifferenceReasons$ | async"
        [tsl-existingDomains]="existingDomains" [tsl-supplierCode]="supplierCode"
        (tsl-onSave)="emailDomainSubmit($event.emailDomain)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)"
    >
    </app-domain-edit>
    <div class="button-container">
        <button class="action-btn" tsl-button size="small" color="black" unfilled (click)="onClose()"
            i18n="@@Cancel" t="Cancel">Cancel</button>
        <button class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
            i18n="@@Submit" t="Submit">Submit</button>
    </div>
</div>